<mat-card class="flex flex-col shadow-xl border-2 rounded bg-white h-full" [appDynamicStyles]="{ 'gap': {zoomout: '12px', zoomin: '8px'} }">
    <!-- Card -->
    <mat-card-header [appDynamicStyles]="{'padding': {zoomout: '16px 16px 0px 16px', zoomin: '8px 12px 0px 12px'} }">
        <mat-card-title class="font-semibold" [appDynamicStyles]="{ 'font-size': {zoomout: '18px', zoomin: '14.5px'} }">
            {{card.title}}
        </mat-card-title>
    </mat-card-header>
    <mat-divider class="static divide-black opacity-12 ml-3 mr-3"></mat-divider>
    <ng-container 
        *ngTemplateOutlet="this[card.id]"></ng-container>
</mat-card>


<!-- Week Flag -->
<ng-template #weekFlag>
    <ng-container *ngTemplateOutlet="flag; context: {flagType: 'Week'}"></ng-container>
</ng-template>

<!-- Month Flag -->
<ng-template #monthFlag>
    <ng-container *ngTemplateOutlet="flag; context: {flagType: 'Month'}"></ng-container>
</ng-template>

<ng-template #sustainabilityFlag>

  <mat-card-content>
    <ng-select
      [(ngModel)]="selectedSustainabilityOption"
      [items]="sustainabilityDropdownOptions"
      bindLabel="label"
      bindValue="value"
      placeholder="Select Month"
      (change)="checkIfFlagSubmitted()"
      appendTo="body"
      [virtualScroll]="true"
      [appDynamicStyles]="{ 'font-size': {zoomout: '14px', zoomin: '12px'} }"
    >
    </ng-select>
  </mat-card-content>

  <mat-card-actions class="flex flex-row justify-center gap-3 py-0">
    <ng-container *ngTemplateOutlet="button; context: {flagType: 'Sustainability', flagMetric: 'Sustainability'}"></ng-container>
  </mat-card-actions>

  <app-sustainability-entry-table
    class="block"
    [rowData]="sustainabilityData"
    [isFlagSubmitted]="isFlagSubmitted"
    (flagCompletionDeleted)="onFlagCompletionDeleted($event)">
  </app-sustainability-entry-table>

</ng-template>



<ng-template #flag let-flagType="flagType">
    <mat-card-content>
        <!-- Select Date Range -->
        <ng-select
        (change)="onSelectChangeHandler()"
        [(ngModel)]="selected"
        [items]="options"
        [virtualScroll]="true"
        bindLabel="option"
        placeholder="Select {{ flagType }}"
        appendTo="body"
        dropdownPosition="bottom"
        [appDynamicStyles]="{ 'font-size': {zoomout: '14px', zoomin: '12px'} }"
        >
        </ng-select>
    </mat-card-content>
    <mat-card-actions class="flex flex-row justify-center gap-3 py-0">
        <ng-container *ngTemplateOutlet="button; context: {flagType: flagType, flagMetric: 'Time'}"></ng-container>
        <ng-container *ngTemplateOutlet="button; context: {flagType: flagType, flagMetric: 'Expense'}"></ng-container>       
    </mat-card-actions>
</ng-template>

<!-- Time and Expense Flag Buttons -->
<ng-template #button let-flagType="flagType" let-flagMetric="flagMetric">
  <!-- Special case: Sustainability flag -->
  <ng-container *ngIf="flagType === 'Sustainability'; else defaultButton">
    <div class="flex flex-col items-center w-full">
      <button mat-raised-button matTooltip="Sustainability Complete"
              id="sustainability-{{ flagMetric }}"
              matTooltipClass="sidenavTooltip"
              class="flag_button--design w-full bg-green-200 text-black"  
              [disabled]="isFlagSubmitted || isSelectedMonthPastDeadline() || !hasSustainabilityEntries"
              (click)="onSubmitSustainabilityFlag()">
        <div class="flex flex-row gap-1 justify-center items-center">
          <div>{{ flagMetric }}</div>
          <div><mat-icon [svgIcon]="'flag'"></mat-icon></div> <!-- use eco icon or sustainability-specific icon -->
        </div>
      </button>
      <div *ngIf="!hasSustainabilityEntries && !isFlagSubmitted && !isSelectedMonthPastDeadline()" class="text-center text-xs text-amber-700 font-medium mt-1">
        At least one sustainability entry is required to submit the flag.
      </div>
    </div>
  </ng-container>

  <!-- Default case -->
  <ng-template #defaultButton>
    <button mat-raised-button matTooltip="{{ flagType }} {{ flagMetric }} Complete"
            id="{{ flagType }} - {{ flagMetric }}"
            matTooltipClass="sidenavTooltip"
            class="flag_button--design w-full"
            [disabled]="isFlagSubmitted"
            (click)="flagClickHandler(flagMetric)">
      <div class="flex flex-row gap-1 justify-center items-center">
        <div>{{ flagMetric }}</div>
        <div><mat-icon [svgIcon]="'flag'"></mat-icon></div>
      </div>
    </button>
  </ng-template>
</ng-template>
